/**
 * This is for any promotional links introduced in the notes field.
 * Instead of a button box that existed below the notes field. The button box
 * is still in ./gift-promotion.js . Clicking the icons it opens the overpanel
 * and allows users to continue with action.
 */

import PropTypes from 'prop-types'
import React from 'react'
import { GiftIcon } from '@paypalcorp/pp-react'
import { StyleSheet, css } from 'lib/paypalphrodite'
import * as media from '../../lib/styles/media-queries'
import classnames from 'classnames'
import TooltipTarget from '../containers/vx-tooltip/target'
import { isBFXCurrencyConversionTrmt } from '../../experiments/bfx-currency-conversion'
import content from 'pp-react-l10n'

let i18n = content('transfer/page/preview')
const styles = StyleSheet.create({
  promotions: {
    color: '#9DA3A6',
    fontSize: 40,
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    [media.smallAndSmaller]: {
      padding: '0 18px',
    },
    [media.extraSmallAndSmaller]: {
      padding: '0 8px',
    },
    ':hover': {
      color: '#0070ba',
    },
  },
  promotionContainer: {
    position: 'absolute',
    zIndex: 2,
    display: 'block',
    right: 0,
    bottom: '13px',
  },
  bfxPromotionContainer: {
    position: 'absolute',
    zIndex: 2,
    display: 'block',
    right: 0,
    bottom: '3px', // move it down a bit more
  },
  topZero: {
    top: 0,
  },
  promotionsActive: {
    color: '#0070ba',
  },
})

class PromotionLinks extends React.Component {
  static propTypes = {
    openGiftThemeOverpanel: PropTypes.func,
    themeHasBeenSelected: PropTypes.bool.isRequired,
    shouldShowGift: PropTypes.bool,
    isNoteEditable: PropTypes.bool.isRequired,
    note: PropTypes.string.isRequired,
  }

  state = {
    giftEntryHover: false,
    shouldShowGift: false,
    openGiftThemeOverpanel: () => {},
  }

  handleGiftEntryHover = () => {
    this.setState({ giftEntryHover: !this.state.giftEntryHover })
  }

  renderGiftEntry = () => {
    const {
      openGiftThemeOverpanel,
      themeHasBeenSelected,
      shouldShowGift,
    } = this.props
    if (!shouldShowGift || themeHasBeenSelected) {
      return null
    }

    const promotionClasses = classnames(css(styles.promotions))

    return (
      <TooltipTarget
        dataTestId="gift-promotion"
        verticalPosition="top"
        horizontalPosition="right"
        content={i18n('promotion.gift')}
        isClickable={true}
        isHoverable={true}
        handleClick={openGiftThemeOverpanel}
        renderTarget={([, targetProps]) => {
          return (
            <GiftIcon
              {...targetProps}
              as="button" // render it as button for a11y
              type="button"
              name="gift"
              size="lg"
              className={promotionClasses}
              aria-label={i18n('a11y.promotion.gift.label')}
            />
          )
        }}
      />
    )
  }

  render() {
    const { note, isNoteEditable } = this.props

    const containerClasses = {
      [css(styles.promotionContainer)]: !isBFXCurrencyConversionTrmt(),
      [css(styles.bfxPromotionContainer)]: isBFXCurrencyConversionTrmt(),
      [css(styles.topZero)]: !note && !isNoteEditable,
    }

    return (
      <div className={classnames(containerClasses)}>
        {this.renderGiftEntry()}
      </div>
    )
  }
}

export default PromotionLinks
